module.exports = __webpack_public_path__ + "img/Im9.adc3ae97.png";